import React from 'react';
import { useCachedPermissions } from '../hooks/useCachedPermissions';
import UnitCard from './UnitCard';
import './UnitsGrid.css';

const UnitsGrid = ({ units, onUnitClick }) => {
  const { hasShowUnit } = useCachedPermissions();

  return (
    <div className="units-grid">
      {units.map((unit, idx) => (
        <UnitCard
          key={unit.id || idx}
          image={unit.image}
          images={unit.images}
          name={unit.name}
          label={unit.label}
          description={unit.description}
          onClick={hasShowUnit ? () => onUnitClick && onUnitClick(unit) : undefined}
          isClickable={hasShowUnit}
        />
      ))}
    </div>
  );
};

export default UnitsGrid; 